import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {LOCAL_STORAGE_AUTH_TOKEN} from '@app/constants/Common';

const PrivateRoute = ({children, ...rest}) => {
    // const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
    console.log(`LOCAL_STORAGE_AUTH_TOKEN: ${localStorage.getItem(LOCAL_STORAGE_AUTH_TOKEN)}`)
    let isLoggedIn = !!localStorage.getItem(LOCAL_STORAGE_AUTH_TOKEN)

    return (
        <Route
            {...rest}
            render={({location}) =>
                isLoggedIn ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: '/login',
                            state: {from: location}
                        }}
                    />
                )
            }
        />
    );
};

export default PrivateRoute;
